import React from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { Box, Button, Paper, Stack, Typography } from '@mui/material';

import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import { COLORS } from '../../Constant/COLORS';
import { PROFESSIONAL_STATUS } from '../../Constant/Enums';

import useHandleLogout from '../../Hooks/useHandleLogout';

const COPY = {
  [PROFESSIONAL_STATUS.REQUESTED]: {
    icon: <HourglassEmptyIcon sx={{ fontSize: 60, color: '#b58a00' }} />,
    title: 'Your account is being verified',
    body:
      "Thanks for registering as a professional on Evento. " +
      "Our team is reviewing your details. You'll get an email as soon as your account is approved.",
    tint: '#fff8e1',
  },
  [PROFESSIONAL_STATUS.REJECTED]: {
    icon: <CancelOutlinedIcon sx={{ fontSize: 60, color: '#b00020' }} />,
    title: 'Your application was not approved',
    body:
      "We're sorry, your professional application has been rejected. " +
      'If you believe this is a mistake, please contact our support team.',
    tint: '#fdecea',
  },
};

const ProfessionalStatus = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleLogout = useHandleLogout();

  const status = location.state?.status ?? PROFESSIONAL_STATUS.REQUESTED;
  const copy = COPY[status] ?? COPY[PROFESSIONAL_STATUS.REQUESTED];

  const onLogout = async () => {
    await handleLogout();
    navigate('/professional/login');
  };

  return (
    <Box
      minHeight='100vh'
      display='flex'
      alignItems='center'
      justifyContent='center'
      bgcolor={COLORS.canvas}
      px={2}
      py={4}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 560,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          p: { xs: 3, sm: 5 },
          textAlign: 'center',
        }}
      >
        <Stack alignItems='center' gap={2}>
          <Box
            sx={{
              width: 100,
              height: 100,
              borderRadius: '50%',
              backgroundColor: copy.tint,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {copy.icon}
          </Box>

          <Typography variant='h5' fontWeight={700}>
            {copy.title}
          </Typography>

          <Typography color='text.secondary'>{copy.body}</Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} gap={1.5} mt={2}>
            <Button variant='outlined' onClick={() => navigate('/')} sx={{ color: COLORS.blue }}>
              Back to home
            </Button>
            <Button variant='contained' color='blue' onClick={onLogout} sx={{ color: '#fff' }}>
              Logout
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

export default ProfessionalStatus;
